import { IconProps } from "./types";
import React from "react";

export const LockIcon = ({
  className,
  fill = "currentColor",
  width = 24,
  height = 24,
  style = {},
}: IconProps): React.ReactElement => (
  <svg
    height={height}
    width={width}
    viewBox="0 0 24 24"
    className={className}
    style={style}
    fill="none"
  >
    <path
      d="M15.75 9.74768V5.29456C15.75 4.29999 15.3549 3.34617 14.6517 2.64291C13.9484 1.93964 12.9946 1.54456 12 1.54456C11.0054 1.54456 10.0516 1.93964 9.34835 2.64291C8.64509 3.34617 8.25 4.29999 8.25 5.29456V9.74768"
      stroke={fill}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.25 9.74768H6.75C5.50736 9.74768 4.5 10.755 4.5 11.9977V20.2477C4.5 21.4903 5.50736 22.4977 6.75 22.4977H17.25C18.4926 22.4977 19.5 21.4903 19.5 20.2477V11.9977C19.5 10.755 18.4926 9.74768 17.25 9.74768Z"
      stroke={fill}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
